import TrackUtil from 'core/utils/TrackUtil';

/**
 * Fire google ecom purchase conversions, etc
 * Ref: https://developers.google.com/analytics/devguides/collection/gtagjs/enhanced-ecommerce#measure_purchases
 *
 * @param {Object} order
 * @param {Object} cart
 */
export default function fireGtagPurchase(order, cart) {
	const orderTotal = order.totalWithServiceFee || order.total;
	const items = getItemsFromCart(cart, order.id, order?.featuredCategory);

	const p1 = TrackUtil.trackEvent("success", {
		gtag: [{
			event_category: "mp_checkout",
			event_label: cart?.store?.name,
			value: Math.round(orderTotal / 100)
		}],
	});

	const p2 = TrackUtil.trackEvent("purchase", {
		gtag: [{
			transaction_id: order.id,  // Transaction ID. Required.
			affiliation: cart?.store?.name,  // Affiliation or store name.
			value: (orderTotal / 100),  // Grand Total. Includes taxes, shipping, discounts
			currency: order.currencyCode,  // Currency Code.
			tax: (order.totalTax / 100),  // Tax.
			shipping: (order.totalShipping / 100),  // Net Shipping after discount
			items: items,
		}],
	});

	return Promise.allSettled([p1, p2]);
}


const getItemsFromCart = (cart, orderId, featuredCategory) => {
	if (!cart?.products?.length > 0) return [];
	return cart.products.map((cp) => ({
		id: orderId,  // Transaction ID. Required.
		name: cp?.productInstance?.product?.name,  // Product name. Required.
		brand: cart?.store?.name,
		category: featuredCategory,  // Category or variation.
		price: (cp.price / 100),  // Unit price.
		quantity: cp.quantity,  // Quantity.
	}));
};
